import { createSlice } from "@reduxjs/toolkit";

const getServicesSlice = createSlice({
  name: "get services",
  initialState: { data: [] },
  reducers: {
    getServices: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { getServices } = getServicesSlice.actions;

export default getServicesSlice.reducer;
